export function rgbToHex(r: number, g: number, b: number) {
  return `#${r.toString(16).padStart(2, '0')}${g.toString(16).padStart(2, '0')}${b.toString(16).padStart(2, '0')}`
}

export function constrainColor(value: number, max: number = 200, min: number = 0) {
  return Math.max(min, Math.min(max, value))
}

export function generateGradientColor(fullName: string) {
  if (!fullName) return null

  const parts = fullName.split(' ')
  const first = parts[0]
  const last = parts[1] || parts[0]

  const f1 = first.charCodeAt(0)
  const f2 = first.charCodeAt(first.length - 1)
  const l1 = last.charCodeAt(0)
  const l2 = last.charCodeAt(last.length - 1)

  const seed1 = (f1 + f2 * 3 + fullName.length * 7) % 256
  const seed2 = (l1 * 5 + l2 + fullName.length * 11) % 256
  const seed3 = (f1 + l1 + f2 * 2 + l2 * 2 + fullName.length * 13) % 256

  const color1Red = constrainColor(seed1)
  const color1Green = constrainColor(seed2)
  const color1Blue = constrainColor(seed3)

  const delta = 40

  const color2Red = constrainColor(color1Red + delta)
  const color2Green = constrainColor(color1Green + delta)
  const color2Blue = constrainColor(color1Blue + delta)

  const colorStart = rgbToHex(color1Red, color1Green, color1Blue)
  const colorEnd = rgbToHex(color2Red, color2Green, color2Blue)

  return [colorStart, colorEnd]
}
